import React from 'react';
import {
  Activity, Archive, ArrowDown, ArrowRight, ArrowUp, ArrowUpRight, Ban,
  BarChart, Bell, Book, Bot, Brain, Bug, ChartBar, ChevronDown, ChevronLeft, ChevronRight,
  CircleCheck, CircleHelp, CirclePause, CirclePlay, CircleX, ClipboardList,
  Clock, Cloud, Cpu, CreditCard, Cross, Crosshair, Database, Dna, Download,
  Earth, Eye, Factory, FilePen, FileText, Flame, FlaskConical, Folder, Folders,
  GitBranch, GitFork, Globe, GraduationCap, Grid, HardDrive, HardHat, Heart,
  HeartPulse, Hourglass, Info, Key, Keyboard, Laptop, Layers, Layout, Library,
  Link, ListChecks, LockKeyhole, MemoryStick, Menu, MessageCircle,   MessageSquare,
  Minimize, Monitor, Moon, Network, Package, PanelLeft, Pencil, Pin, Plug,
  Plus, Puzzle, RefreshCw, Repeat, RotateCcw, Satellite, ScanSearch, ScrollText,
  Search, Server, Settings, Shield, ShieldAlert, ShieldCheck, Siren, Sliders,
  Snowflake, Sparkles, Sun, Tag, Target, Terminal, Thermometer, ThumbsUp, Timer,
  TrendingDown, TrendingUp, TriangleAlert, Trash2, Upload, User, Users, Waypoints, X, Zap,
  Copy,
  BadgeCheck, BookOpen, Boxes, Box, Building, Calculator, ChartColumn, ChartLine, CloudCog, Coins, Container, FileCode, FileSearch, Gem, Gauge, LayoutDashboard, LayoutGrid, Lightbulb, List, Radar, Router, ServerCog, ShieldHalf, Table, Wrench,
  OctagonAlert, Stethoscope, PanelsTopLeft, Workflow, Save, DatabaseBackup, ChartPie, Send, Warehouse, ScanEye, Wind,
} from 'lucide-react';

// data-lucide (kebab-case) name -> lucide-react component
const ICONS = {
  activity: Activity,
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-up-right': ArrowUpRight,
  ban: Ban,
  'bar-chart': BarChart,
  bell: Bell,
  book: Book,
  bot: Bot,
  brain: Brain,
  bug: Bug,
  'chart-bar': ChartBar,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'check-circle': CircleCheck,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-pause': CirclePause,
  'circle-play': CirclePlay,
  'circle-x': CircleX,
  'clipboard-list': ClipboardList,
  clock: Clock,
  cloud: Cloud,
  copy: Copy,
  cpu: Cpu,
  'credit-card': CreditCard,
  cross: Cross,
  crosshair: Crosshair,
  database: Database,
  disk: HardDrive,
  dna: Dna,
  download: Download,
  earth: Earth,
  eye: Eye,
  factory: Factory,
  'file-pen': FilePen,
  'file-text': FileText,
  flame: Flame,
  'flask-conical': FlaskConical,
  folder: Folder,
  folders: Folders,
  'git-branch': GitBranch,
  'git-fork': GitFork,
  globe: Globe,
  'graduation-cap': GraduationCap,
  grid: Grid,
  'hard-drive': HardDrive,
  'hard-hat': HardHat,
  heart: Heart,
  'heart-pulse': HeartPulse,
  'help-circle': CircleHelp,
  hourglass: Hourglass,
  info: Info,
  key: Key,
  keyboard: Keyboard,
  laptop: Laptop,
  layers: Layers,
  layout: Layout,
  library: Library,
  link: Link,
  'list-checks': ListChecks,
  'lock-keyhole': LockKeyhole,
  'memory-stick': MemoryStick,
  menu: Menu,
  memory: MemoryStick,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  minimize: Minimize,
  monitor: Monitor,
  moon: Moon,
  network: Network,
  package: Package,
  'panel-left': PanelLeft,
  'panel-right': PanelLeft,
  pencil: Pencil,
  pin: Pin,
  'play-circle': CirclePlay,
  plug: Plug,
  plus: Plus,
  puzzle: Puzzle,
  'refresh-cw': RefreshCw,
  repeat: Repeat,
  'rotate-ccw': RotateCcw,
  satellite: Satellite,
  'scan-search': ScanSearch,
  'scroll-text': ScrollText,
  search: Search,
  server: Server,
  settings: Settings,
  shield: Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  siren: Siren,
  sliders: Sliders,
  snowflake: Snowflake,
  sparkles: Sparkles,
  sun: Sun,
  tag: Tag,
  target: Target,
  terminal: Terminal,
  thermometer: Thermometer,
  'thumbs-up': ThumbsUp,
  timer: Timer,
  'trending-down': TrendingDown,
  'trending-up': TrendingUp,
  'alert-triangle': TriangleAlert,
  'triangle-alert': TriangleAlert,
  'trash-2': Trash2,
  trash: Trash2,
  upload: Upload,
  user: User,
  users: Users,
  waypoints: Waypoints,
  x: X,
  zap: Zap,
    'workflow': Workflow,
    'save': Save,
    'database-backup': DatabaseBackup,
    'chart-pie': ChartPie,
    'send': Send,
    'warehouse': Warehouse,
    'scan-eye': ScanEye,
    'wind': Wind,
    'octagon-alert': OctagonAlert,
    'stethoscope': Stethoscope,
    'panels-top-left': PanelsTopLeft,
   'badge-check': BadgeCheck,
   'book-open': BookOpen,
   'boxes': Boxes,
   'box': Box,
   'building': Building,
   'calculator': Calculator,
   'chart-column': ChartColumn,
   'chart-line': ChartLine,
   'cloud-cog': CloudCog,
   'coins': Coins,
   'container': Container,
   'file-code': FileCode,
   'file-search': FileSearch,
   'gem': Gem,
   'gauge': Gauge,
   'layout-dashboard': LayoutDashboard,
   'layout-grid': LayoutGrid,
   'lightbulb': Lightbulb,
   'list': List,
   'radar': Radar,
   'router': Router,
   'server-cog': ServerCog,
   'shield-half': ShieldHalf,
   'table': Table,
   'wrench': Wrench,
};

function Icon({ name, size = 16, className = '', ...rest }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return <Cmp size={size} className={className} {...rest} />;
}

export default Icon;
